import React, { useEffect, useState } from 'react'
import api from '../../services/api'
import '../../css/tickets.css'

export default function TicketCategories() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [adding, setAdding] = useState(false)
  const [newName, setNewName] = useState('')
  const [editingId, setEditingId] = useState(null)
  const [editName, setEditName] = useState('')

  const load = async () => {
    setLoading(true); setError('')
    try {
      const { data } = await api.get('/ticket-categories')
      setRows(data)
    } catch {
      setError('Errore nel caricamento categorie')
    } finally { setLoading(false) }
  }

  useEffect(() => { load() }, [])

  const add = async (e) => {
    e.preventDefault()
    if (!newName.trim()) return
    try {
      setAdding(true)
      await api.post('/ticket-categories', { name: newName.trim() })
      setNewName('')
      load()
    } catch {
      setError('Creazione categoria fallita')
    } finally { setAdding(false) }
  }

  const startEdit = (row) => {
    setEditingId(row.id)
    setEditName(row.name)
  }
  const cancelEdit = () => { setEditingId(null); setEditName('') }
  const saveEdit = async (id) => {
    if (!editName.trim()) return
    try {
      await api.put(`/ticket-categories/${id}`, { name: editName.trim() })
      cancelEdit(); load()
    } catch {
      setError('Rinomina fallita (nome duplicato?)')
    }
  }

  const remove = async (id) => {
    if (!window.confirm('Eliminare la categoria?')) return
    try {
      await api.delete(`/ticket-categories/${id}`)
      load()
    } catch {
      setError('Eliminazione fallita (categoria in uso?)')
    }
  }

  if (loading) return <div className="tickets-row body">Carico…</div>
  if (error)   return <div className="tickets-row body error">{error}</div>

  return (
    <div className="tickets-wrap">
      <form className="cat-form" onSubmit={add}>
        <input
          type="text"
          placeholder="Nuova categoria…"
          value={newName}
          onChange={e=>setNewName(e.target.value)}
        />
        <button className="btn btn-primary" type="submit" disabled={adding}>
          {adding ? 'Aggiungo…' : 'Aggiungi'}
        </button>
      </form>

      <div className="cats-list">
        <div className="cats-head">
          <span>ID</span><span>Nome</span><span className="actions">Azioni</span>
        </div>

        {rows.map(r => (
          <div key={r.id} className="cats-row">
            <span data-label="ID">#{r.id}</span>

            <span data-label="Nome" className="cat-name">
              {editingId === r.id ? (
                <input
                  className="cat-edit"
                  value={editName}
                  onChange={e=>setEditName(e.target.value)}
                  onKeyDown={e=>{ if (e.key==='Enter') saveEdit(r.id) }}
                />
              ) : r.name}
            </span>

            <div className="actions">
              {editingId === r.id ? (
                <>
                  <button className="btn" onClick={()=>saveEdit(r.id)}>Salva</button>
                  <button className="btn btn-outline" onClick={cancelEdit}>Annulla</button>
                </>
              ) : (
                <>
                  <button className="btn" onClick={()=>startEdit(r)}>Rinomina</button>
                  <button className="btn btn-outline" onClick={()=>remove(r.id)}>Elimina</button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
